module.exports = __webpack_public_path__ + "img/opiniones.81d727a9.svg";